import { Injectable, inject } from '@angular/core';
import { BackendService } from '@forgerock/backstage-ui-core';
import { firstValueFrom } from 'rxjs';
import { DocsConfigFamily, DocsConfigItem, DocsConfigProduct } from './model/docs';

@Injectable({
  providedIn: 'root'
})
export class DocService {
  private backend = inject(BackendService);

  private url = '/docs-ws/api/v1/docset/_structured';
  private config: Promise<DocsConfigFamily[]>;

  getConfig(): Promise<DocsConfigFamily[]> {
    if (!this.config) {
      this.config = firstValueFrom(
        this.backend.get(this.url)
      );
    }
    return this.config;
  }

  private async getProduct(productId: string): Promise<DocsConfigProduct> {
    return (await this.getConfig())
      .flatMap(it => it.groups)
      .find(it => it.id === productId);
  }

  async getProductName(productId: string): Promise<string> {
    return (await this.getProduct(productId))?.title ?? productId;
  }

  async getBook(productId: string, version: string, bookId: string): Promise<DocsConfigItem> {
    return (await this.getProduct(productId))
      ?.docsets
      .find(it => it.version === version)
      ?.groups
      ?.flatMap(it => it.books)
      ?.find(it => it.id === bookId);
  }

}
